export default [
    {
        inputdata: '',
        title: '年度',
        fontSize: '14px',
        color: '#333333',
        placeholder: '请选择',
        types: 'year',
        inputtype: 'datey',
        width: '210px',
        lablewith: '110px'
    },
    {
        inputdata: '',
        title: '月份',
        fontSize: '14px',
        color: '#333333',
        placeholder: '请选择',
        types: '',
        inputtype: 'select',
        width: '210px',
        lablewith: '110px',
        options: [
            { key: '1', value: '1月' },
            { key: '2', value: '2月' },
            { key: '3', value: '3月' },
            { key: '4', value: '4月' },
            { key: '5', value: '5月' },
            { key: '6', value: '6月' },
            { key: '7', value: '7月' },
            { key: '8', value: '8月' },
            { key: '9', value: '9月' },
            { key: '10', value: '10月' },
            { key: '11', value: '11月' },
            { key: '12', value: '12月' }
        ]
    },
    {
        inputdata: '',
        title: '产品线',
        fontSize: '14px',
        color: '#333333',
        placeholder: '请选择',
        types: '',
        inputtype: 'select',
        width: '220px',
        options: [],
        lablewith: '110px'
    },
    {
        inputdata: '',
        title: '平台编号',
        fontSize: '14px',
        color: '#333333',
        placeholder: '请选择',
        types: '',
        inputtype: 'select',
        width: '220px',
        options: [],
        lablewith: '110px'
    },
    {
        inputdata: '',
        title: '项目',
        fontSize: '14px',
        color: '#333333',
        placeholder: '请输入',
        types: 'text',
        inputtype: 'input',
        width: '210px',
        lablewith: '110px'
    },
    {
        inputdata: '',
        title: '调整值',
        fontSize: '14px',
        color: '#333333',
        placeholder: '请输入',
        types: 'number',
        inputtype: 'input',
        width: '210px',
        lablewith: '110px'
    }
]